export const REGEX_PATTERNS = {
    emailPattern: new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
    passwordPattern: new RegExp('[^a-zA-Z s]'),
};
